console.log("Script from block two frontend.js loaded");
